// MARQUEE — testo scorrevole orizzontale con pausa al hover.
// HTML richiesto: .marquee-track > .marquee-text dentro .marquee-section.
function initMarquee() {
    const track = document.querySelector('.marquee-track');
    if (track) {
        const section = track.closest('.marquee-section');
        if (section) {
            section.addEventListener('mouseenter', () => track.classList.add('is-paused'));
            section.addEventListener('mouseleave', () => track.classList.remove('is-paused'));
        }
    }
}

export {initMarquee};
